<script setup>
import Toast from 'primevue/toast';
import { useToast } from 'primevue/usetoast';

const toast = useToast();

const props = defineProps({
    toastSeverity: {
        type: String,
        default: 'success' // (info, success, error, warn)
    }
});

const showToast = (severity, summary, detail, life = 900, group = 'br') => {
    toast.add({
        severity: severity || props.toastSeverity,
        summary,
        detail,
        life: severity === 'success' ? life : 1800,
        group
    });
};

const showToastAlarm = (summary, detail) => {
    toast.add({
        severity: 'secondary',
        summary,
        detail,
        life: 2500,
        group: 'tr'
    });
};

defineExpose({ showToast, showToastAlarm });
</script>

<template>
    <Toast position="bottom-right" group="br" />
    <Toast position="top-right" group="tr" style="z-index: 9999; margin-top: 2.2rem; margin-right: 4rem" />
    <Toast position="top-center" group="tc" style="z-index: 9999" />
    <Toast position="bottom-center" group="bc" style="z-index: 9999" />
</template>

<style>
.p-toast-message.p-toast-message-success {
    background-color: #0038ea;
    opacity: 0.8;
    color: white;
    border: none;
    border-radius: 0.8em;
}

.p-toast-message.p-toast-message-error {
    background-color: red;
    opacity: 0.6;
    color: white;
    border: none;
    border-radius: 0.8em;
}

.p-toast-message.p-toast-message-warn {
    background-color: #ff9813;
    opacity: 0.8;
    color: white;
    border: none;
    border-radius: 0.8em;
}

.p-toast-message.p-toast-message-info {
    background-color: #1d970c;
    opacity: 0.8;
    color: white;
    border: none;
    border-radius: 0.8em;
}

.p-toast-message.p-toast-message-secondary {
    background-color: #0038ea;
    opacity: 0.7;
    color: white;
    border: none;
    border-radius: 0.8em;
}

/* 요약 색상 변경 */
.p-toast .p-toast-message .p-toast-summary {
    color: white;
    font-family: 'SCoreDream500';
    font-size: 0.95rem;
}

/* 세부 색상 변경 */
.p-toast .p-toast-message .p-toast-detail {
    color: white;
    font-family: 'SCoreDream400';
    font-size: 0.9rem;
}
</style>
